export const environment = {
  env: "development",
  production: false,
  apiBaseUrl: "https://api.dev.mana-vi.ck1lab.net",
  s3Url: "https://dev.mana-vi.ck1lab.net/",
  cfVideoBase: "https://dev.mana-vi.ck1lab.net/",
  encryptionKey: "MaNaVi@2026!Dev!Encryption!AES256!Key#K7mQ9pL3xN8vR2wY5zH4bF6jT1cS0eA"
};
